import { render } from "./ChangeObjectForm.vue?vue&type=template&id=70033622"
import script from "./ChangeObjectForm.vue?vue&type=script&lang=js"
export * from "./ChangeObjectForm.vue?vue&type=script&lang=js"

import "./ChangeObjectForm.vue?vue&type=style&index=0&id=70033622&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__